import type { ComboboxOption } from '../../components/ui/Combobox';
import { getLanguage } from '../../lib/i18n';

/**
 * Departman ve rol listeleri.
 *
 * Hazır seçenekler veritabanına anahtarlarıyla yazılıyor (`product`,
 * `team-lead` gibi); böylece dil değişince etiket de değişiyor. Kullanıcı
 * listede olmayan bir şey yazarsa (creatable select) yazdığı metin olduğu gibi
 * saklanıyor ve olduğu gibi gösteriliyor.
 */

interface Entry {
  value: string;
  tr: string;
  en: string;
}

const DEPARTMENTS: Entry[] = [
  { value: 'management', tr: 'Yönetim', en: 'Management' },
  { value: 'product', tr: 'Ürün', en: 'Product' },
  { value: 'engineering', tr: 'Mühendislik', en: 'Engineering' },
  { value: 'design', tr: 'Tasarım', en: 'Design' },
  { value: 'data', tr: 'Veri ve analitik', en: 'Data & analytics' },
  { value: 'sales', tr: 'Satış', en: 'Sales' },
  { value: 'marketing', tr: 'Pazarlama', en: 'Marketing' },
  { value: 'customer-success', tr: 'Müşteri başarısı', en: 'Customer success' },
  { value: 'finance', tr: 'Finans', en: 'Finance' },
  { value: 'people', tr: 'İnsan kaynakları', en: 'People & HR' },
  { value: 'operations', tr: 'Operasyon', en: 'Operations' },
  { value: 'legal', tr: 'Hukuk', en: 'Legal' },
];

const ROLES: Entry[] = [
  { value: 'founder', tr: 'Kurucu', en: 'Founder' },
  { value: 'executive', tr: 'Üst yönetim', en: 'Executive' },
  { value: 'director', tr: 'Direktör', en: 'Director' },
  { value: 'manager', tr: 'Müdür', en: 'Manager' },
  { value: 'team-lead', tr: 'Takım lideri', en: 'Team lead' },
  { value: 'senior-specialist', tr: 'Kıdemli uzman', en: 'Senior specialist' },
  { value: 'specialist', tr: 'Uzman', en: 'Specialist' },
  { value: 'consultant', tr: 'Danışman', en: 'Consultant' },
  { value: 'freelancer', tr: 'Serbest çalışan', en: 'Freelancer' },
  { value: 'intern', tr: 'Stajyer', en: 'Intern' },
];

const label = (entry: Entry): string => (getLanguage() === 'en' ? entry.en : entry.tr);

const toOptions = (entries: Entry[]): ComboboxOption[] =>
  entries.map((entry) => ({ value: entry.value, label: label(entry) }));

export const departmentOptions = (): ComboboxOption[] => toOptions(DEPARTMENTS);
export const roleOptions = (): ComboboxOption[] => toOptions(ROLES);
